<template>
  <div
    class="relative cursor-pointer rounded-lg border
      border-gray-500 w-24 h-24 md:w-48 md:h-48
      flex md:flex-col items-center justify-center p-4 md:p-8 text-black">
      <component :is="`ebr-icon-${icon}`"></component>
      <div class="text-left ml-4 md:ml-0 md:mt-4">
        <span><b>{{title}}</b></span><br>
        <span>{{description}}</span>
      </div>
  </div>
</template>

<script>
import PatenteVue from '../icons/Patente.vue';
import BarcaDaPescaVue from '../icons/BarcaDaPesca.vue';
import AssicurazioneVue from '../icons/Assicurazione.vue';
import BenzinaVue from '../icons/Benzina.vue';
import BereVue from '../icons/Bere.vue';
import CiboVue from '../icons/Cibo.vue';
import CostruttoreVue from '../icons/Costruttore.vue';
import FrigoVue from '../icons/Frigo.vue';
import LarghezzaVue from '../icons/Larghezza.vue';
import MotoreBarcaVue from '../icons/MotoreBarca.vue';
import NoleggioAGiorniVue from '../icons/NoleggioAGiorni.vue';
import ParcheggioVue from '../icons/Parcheggio.vue';
import PresaDellaCorrenteVue from '../icons/PresaDellaCorrente.vue';
import RadioVue from '../icons/Radio.vue';
import SciNauticoVue from '../icons/SciNautico.vue';
import SkipperVue from '../icons/Skipper.vue';
import TendalinoVue from '../icons/Tendalino.vue';

export default {
  name: 'ebr-slide',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  components: {
    'ebr-icon-assicurazione': AssicurazioneVue,
    'ebr-icon-barca-da-pesca': BarcaDaPescaVue,
    'ebr-icon-benzina': BenzinaVue,
    'ebr-icon-bere': BereVue,
    'ebr-icon-cibo': CiboVue,
    'ebr-icon-costruttore': CostruttoreVue,
    'ebr-icon-frigo': FrigoVue,
    'ebr-icon-larghezza': LarghezzaVue,
    'ebr-icon-motore-barca': MotoreBarcaVue,
    'ebr-icon-noleggio-a-giorni': NoleggioAGiorniVue,
    'ebr-icon-parcheggio': ParcheggioVue,
    'ebr-icon-patente': PatenteVue,
    'ebr-icon-presa-della-corrente': PresaDellaCorrenteVue,
    'ebr-icon-radio': RadioVue,
    'ebr-icon-sci-nautico': SciNauticoVue,
    'ebr-icon-skipper': SkipperVue,
    'ebr-icon-tendalino': TendalinoVue,
  },
};
</script>

<style>

</style>
